import React, {useMemo, useState} from "react";
import {TreeNode} from "../../../../types/Post";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Typography} from "../../../../designSystem/components/Typography";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {CustomDialog} from "../../../../components/DialogCustom";

interface AddCategoryDialogProps {
  initialCategory: TreeNode;
  onCancel: () => void;
  onAdd: (newCategory: { name: string; level: number; parentId: string }) => void;
}

export const AddCategoryDialog = ({ initialCategory, onCancel, onAdd }: AddCategoryDialogProps) => {
  const [name, setName] = useState<string>('');

  const parentName = useMemo(() => {
    return initialCategory ? initialCategory.name : ''
  }, [initialCategory])

  const submit = (name: string) => {
    onAdd({
      name,
      level: initialCategory.level + 1,
      parentId: initialCategory.id,
    })
  }

  return (
    <CustomDialog>
      <div className="flex flex-col gap-4 text-left">
        <Typography variant="title">
          新增分類
        </Typography>
        {parentName && (
          <Typography variant="bodyBold">
            將新增到：{parentName}
          </Typography>
        )}
        <BaseInput
          label="分類名稱"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="輸入分類名稱"
        />

        <div className="flex justify-end gap-2 mt-4">
          <ActionButton
            label="取消"
            onClick={onCancel}
            color="secondary"
          />
          <ActionButton
            label="新增"
            onClick={() => submit(name.trim())}
            disabled={!name.trim()}
            iconName="fa-plus"
          />
        </div>
      </div>
    </CustomDialog>
  );
};
